import { backgroundTransitionOnClick, IconFont, pointer } from '@byecode/ui'
import styled, { css } from 'styled-components'

export const ComponentPanelContainer = styled.aside`
    position: relative;
    height: 100%;
    display: flex;
    flex-shrink: 0;
    /* overflow: hidden; */
    /* border-right: 1px solid var(--color-gray-200); */
    background-color: var(--color-white);
`

export const Header = styled.div`
    width: 250px;
    display: flex;
    flex-direction: column;
    margin: 12px;
    margin-bottom: 0;
`

export const Icon = styled(IconFont)<{ size?: number; color?: string; isAction?: boolean; hoverColor?: string; isUsed?: boolean }>`
    font-size: ${({ size }) => size ?? 16}px;
    /* transition: all 0.3s ease-in-out; */
    ${({ isAction }) => isAction && `${backgroundTransitionOnClick}`}
    color: ${({ color }) => color ?? 'var(--color-gray-400)'};
    flex-shrink: 0;

    ${pointer}
    ${({ isUsed }) =>
        isUsed &&
        css`
            color: var(--color-black);
            background-color: var(--color-gray-100);
            border-radius: 3px;
        `}
`

export const Chunk = styled.div`
    width: 256px;
    height: 100%;
    z-index: 0;
    background-color: var(--color-white);
    /* margin-right: 24px; */
`

export const IconWrapper = styled.div<{ size?: number; radius?: number }>`
    /* padding: 0px 8px; */
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${({ radius }) => `${radius ?? 6}px`};
    flex-shrink: 0;
    color: var(--color-gray-400);
    cursor: pointer;
`
